import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Checkbox } from '@material-ui/core';
import { TAttachableObject } from '../../../types/common';

type TProps = {
  name: any;
  required?: boolean;
  onChange?: () => void;
  checked?: boolean;
};

export const SiteProcessCheckbox: React.VFC<TProps> = React.memo(
  (props: TProps) => {
    const { name, required = false, onChange, checked } = props;

    const extraProps: TAttachableObject = {};

    if (typeof checked !== 'undefined' && checked !== null) {
      extraProps.checked = checked;
    }

    // react-hook-formを使用する前提のcomponent
    const { register, control } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Checkbox
            {...register(name, { required: required })}
            onChange={onChange}
            color='primary'
            style={{ position: 'relative', top: -2 }}
            {...extraProps}
          />
        )}
      />
    );
  }
);
